import styled from 'styled-components';
import {
  gray,
  grayDark,
  grayDarker,
  grayLight,
  blue,
} from '@bufferapp/ui/style/colors';

export const WelcomeChecklistWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  width: 224px;

  position: sticky;
  flex-grow: 1;
  flex-shrink: 0;
  bottom: 15px;
`;

export const BottomStyleWrapper = styled.div`
  border: 1px solid ${grayLight};
  border-radius: 4px;
  margin-top: auto;
`;

export const ChecklistHeader = styled.div`
  position: relative;
  background: linear-gradient(92.83deg, #e5eaff 0.48%, #ebeeff 98.57%);
  border-bottom: 1px solid ${grayLight};
`;

export const ChecklistTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  height: 40px;
  padding: 0 8px 0 8px;

  > p {
    font-weight: 500;
    font-size: 15px;
    color: ${grayDarker};
  }

  > svg {
    fill: ${gray};
  }

  > svg:hover {
    cursor: pointer;
  }
`;

export const ProgressBarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 8px 0 8px;

  > p {
    white-space: nowrap;
    margin: 0 8px 12px 0;
    font-size: 12px;
    color: ${grayDark};
  }

  .checklistProgress {
    margin: 0px;
    margin-bottom: 12px;
    background: white;

    > div {
      background-color: ${blue};
    }
  }
`;

export const ChecklistItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  padding: 0 8px 0 8px;

  border-bottom: 1px solid ${grayLight};

  :hover {
    background-color: rgba(224, 224, 224, 0.8);
    cursor: ${(props) => (props.initial ? 'default' : 'pointer')};
  }

  > svg {
    fill: ${gray};
  }
`;

export const ChecklistItemLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  text-decoration: ${(props) => (props.isCompleted ? 'line-through' : 'none')};
`;

export const Checklist = styled.div``;

export const ChecklistFooter = styled.div`
  padding-left: 10px;

  > p {
    font-size: 12px;
    color: ${grayDark};
  }

  #checklist-help-link {
    color: ${grayDark};
  }
`;

// TODO: refactor to a styled component w/ props
export const CheckOff = styled.div`
  border: 1px solid ${grayLight};
  border-radius: 50%;
  width: 16px;
  height: 16px;
  margin-right: 6px;
`;

export const CheckOn = styled.div`
  background-color: ${blue};
  border-radius: 50%;
  width: 16px;
  height: 16px;
  margin-right: 6px;

  > svg {
    fill: white;
  }
`;

export const IconWrapper = styled.div`
  position: absolute;
  width: 64px;
  height: 54px;
  right: -6px;
  top: -26px;
`;
